import { Component, inject, OnInit } from '@angular/core';
import { Api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nav-notas',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './nav-notas.html',
  styleUrls: ['./nav-notas.css']
})
export class NavNotas implements OnInit {
  public contacto_id: string = '';
  private api = inject(Api);
  private alertService = inject(AlertService);
  
  uploadingFiles: boolean = false;
  uploadedFiles: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.contacto_id = params['id'];
      this.getEntityFiles();
    });
  }

  ngOnInit(): void {

  }

  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    
    if (files && files.length > 0) {
      this.uploadingFiles = true;
      
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        console.log('Archivo seleccionado:', file.name);
        this.uploadFile(file);
      }
    }
    
    event.target.value = '';
  }

  uploadFile(file: File) {
    this.api.showLoading();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id_entidad', this.contacto_id);
    formData.append('tipo', 'CNT');
    
    this.api.uploadFile(formData).subscribe({
      next: (response: any) => {
        this.api.hideLoading();
        console.log('Archivo subido exitosamente:', response);
        
        if (response.success) {
          this.getEntityFiles();
          this.alertService.success('Éxito', 'El archivo fue subido exitosamente');
        }
      },
      error: (error: any) => {
        this.api.hideLoading();
        console.error('Error al subir archivo:', error);
        this.alertService.error('Error', `No se pudo subir el archivo: ${file.name}`);
      },
      complete: () => {
        this.uploadingFiles = false;
      }
    });
  }

  onDeleteFile(file: any) {
    const confirmDelete = confirm(`¿Deseas eliminar el archivo "${file.nombre}"?`);

    if (!confirmDelete) return;

    this.api.showLoading();
    this.api.deleteFile({ fileUrl: file.url }).subscribe({
      next: (res: any) => {
        this.api.hideLoading();
        if (res.success) {
          this.uploadedFiles = this.uploadedFiles.filter(f => f.url !== file.url);
          this.alertService.success('Éxito', 'El archivo fue eliminado correctamente');
        } else {
          this.alertService.error('Error', res.message || 'No se pudo eliminar el archivo');
        }
      },
      error: (err: any) => {
        this.api.hideLoading();
        if (err.status === 403) {
          this.alertService.error('Acceso denegado', 'No tienes permiso para eliminar archivos.');
          return;
        }
        console.error('Error al eliminar archivo:', err);
        this.alertService.error('Error', 'No se pudo eliminar el archivo.');
      }
    });
  }


  getEntityFiles() {
    this.api.getEntityFiles({id_entidad: this.contacto_id}).subscribe({
      next: (data: any) => {
        this.uploadedFiles = data.data;
      },
      error: (error: any) => {
        console.error('Error fetching files:', error);
      }
    });
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}